var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottledGas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 41,
    viewBox: "0 0 22 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4.2 9.297V1.315M1.8.816h18.4M10.067 6.803V4.082M17 9.297V1.315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34.286v4.854a.86.86 0 0 1-.855.86H5.055a.86.86 0 0 1-.855-.86v-4.854M1 21.224s9.141 3.657 19.2.025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 36.735c-5.5 0-10-4.563-10-10.141v-9.107c0-5.577 4.5-10.14 10-10.14s10 4.563 10 10.14v9.107c0 5.578-4.5 10.14-10 10.14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottledGas);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSI0MSIgdmlld0JveD0iMCAwIDIyIDQxIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiPgogICAgICAgIDxwYXRoIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik00LjIgOS4yOTdWMS4zMTVNMS44LjgxNmgxOC40TTEwLjA2NyA2LjgwM1Y0LjA4Mk0xNyA5LjI5N1YxLjMxNSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNyAzNC4yODZ2NC44NTRhLjg2Ljg2IDAgMCAxLS44NTUuODZINS4wNTVhLjg2Ljg2IDAgMCAxLS44NTUtLjg2di00Ljg1NE0xIDIxLjIyNHM5LjE0MSAzLjY1NyAxOS4yLjAyNSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMSAzNi43MzVjLTUuNSAwLTEwLTQuNTYzLTEwLTEwLjE0MXYtOS4xMDdjMC01LjU3NyA0LjUtMTAuMTQgMTAtMTAuMTRzMTAgNC41NjMgMTAgMTAuMTR2OS4xMDdjMCA1LjU3OC00LjUgMTAuMTQtMTAgMTAuMTR6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };